var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2987 2.62894C11.0973 1.39496 12.9027 1.39496 13.7013 2.62894C14.2224 3.43426 15.2368 3.76386 16.1318 3.41867C17.5032 2.88973 18.9638 3.95096 18.8845 5.41864C18.8328 6.37648 19.4597 7.23938 20.3867 7.48617C21.807 7.86432 22.3649 9.58141 21.4381 10.7222C20.8333 11.4667 20.8333 12.5333 21.4381 13.2778C22.3649 14.4186 21.807 16.1357 20.3867 16.5138C19.4597 16.7606 18.8328 17.6235 18.8845 18.5814C18.9638 20.049 17.5032 21.1103 16.1318 20.5813C15.2368 20.2361 14.2224 20.5657 13.7013 21.3711C12.9027 22.605 11.0973 22.605 10.2987 21.3711C9.77757 20.5657 8.76317 20.2361 7.8682 20.5813C6.49684 21.1103 5.03619 20.049 5.11546 18.5814C5.1672 17.6235 4.54027 16.7606 3.61332 16.5138C2.19297 16.1357 1.63505 14.4186 2.56187 13.2778C3.16673 12.5333 3.16673 11.4667 2.56187 10.7222C1.63505 9.58141 2.19297 7.86432 3.61332 7.48617C4.54027 7.23938 5.1672 6.37648 5.11546 5.41864C5.03619 3.95096 6.49684 2.88973 7.8682 3.41867C8.76317 3.76386 9.77757 3.43426 10.2987 2.62894Z",
    fill: "#FEAD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L10.5 14.5L8 12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedicon);
export default __webpack_public_path__ + "static/media/verifiedicon.53a8083ca2b099a15da4abc90356518e.svg";
export { ForwardRef as ReactComponent };